import React ,{useState,useEffect,useRef}from "react";
import { Box, Typography, Paper, Stack, Divider,Button,useMediaQuery } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import VerifiedIcon from "@mui/icons-material/Verified";
import EngineeringIcon from "@mui/icons-material/Engineering";

export default function AboutShop({description,taxnumber,established , fax}) {
   const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);
    // const [fax , setFax] = useState("");
  
    useEffect(() => {
      if (textRef.current) {
        setIsOverflowing(
          textRef.current.scrollHeight > textRef.current.clientHeight
        );
      }
    }, [
      // description

    ]);
      const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Box width="100%">
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
          borderRadius: 3,
          border: "1px solid #e5e5e5",
          bgcolor: "#fff",
        }}
      >
        {/* HEADER */}
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          mb={{ xs: 2, md: 3 }}
        >
          <BusinessIcon sx={{ color: "#608900", fontSize: { xs: 24, md: 28 } }} />
          <Typography
            fontWeight={700}
            fontSize={{ xs: 18, sm: 20, md: 22 }}
          >
            About Company
          </Typography>
        </Stack>

        <Divider sx={{ mb: { xs: 2, md: 3 } }} />

        {/* DESCRIPTION */}
         <Box
                sx={{
                  mt: 0,
                  //p: isMobile ? 2 : 3,
                }}
              >
         <Typography
                  ref={textRef}
                  sx={{
                    mt: 2,
                    whiteSpace: "pre-line",
                    display: "-webkit-box",
                    WebkitLineClamp: expanded ? "none" : 4,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    fontSize: { xs: 14, sm: 15, md: 16 },
                    lineHeight: 1.8,
                  }}
                >
                  {"\n"}
               {description || "No description available"}

        </Typography>
        {isOverflowing && (
          <Button
            size="small"
            onClick={() => setExpanded(!expanded)}
            sx={{ mt: 1, textTransform: "none" }}
          >
            {expanded ? "Show less" : "Show more"}
          </Button>
        )}
        </Box>

      <Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr 1fr",
      md: "repeat(3, 1fr)",
    },
    gap: 2,
    mt: 3,
    color: "#608900",
    fontSize: { xs: 13, sm: 14 },
  }}
>
  <Typography>Tax Id No(TIN): {taxnumber}</Typography>
  <Typography>Fax Number: {fax}</Typography>
  <Typography>Year Established: {established}</Typography>
</Box>
      </Paper>
                 
    </Box>
  );
}


